"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPatientStore = void 0;
const zustand_1 = require("zustand");
exports.getPatientStore = zustand_1.default((set) => ({
    mongoId: '',
    name: '',
    dpid: '',
    setDpid: (dpid) => set((state) => (Object.assign(Object.assign({}, state), { dpid }))),
    setName: (name) => set((state) => (Object.assign(Object.assign({}, state), { name }))),
    setMongoId: (mongoId) => set((state) => (Object.assign(Object.assign({}, state), { mongoId }))),
}));
//# sourceMappingURL=getPatientStore.js.map